import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { Cue5050 } from '../../_models/fundraising/Cue5050';
import { TicketOrder } from '../../_models/fundraising/TicketOrder';
import { Cue5050Player } from '../../_models/fundraising/Cue5050Player';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-verify-ticket-modal',
  templateUrl: './verify-winning-ticket-modal.component.html',
  styleUrls: ['./verify-winning-ticket-modal.component.css']
})
export class VerifyTicketModalComponent implements OnInit {

  public form: FormGroup;

  public eventId: number;

  public first: string;
  public last: string;

  public collectName = false;

  @Output() hasError = new EventEmitter();

  constructor(
    private cue5050Service: Cue5050Service,
    private bsModalRef: BsModalRef,
    private fb: FormBuilder
  ) { }

  ngOnInit() { 
    this.cue5050Service.getWinningTicketOrder(this.eventId)
      .subscribe(ticketOrder => {
        this.collectName = !(ticketOrder?.cue5050Player?.firstName && ticketOrder?.cue5050Player?.lastName);     
      })
      this.createForm();

      if (this.collectName){
        this.form.controls.first.disable;
        this.form.controls.last.disable;
      }
  }

  createForm(){
    this.form = this.fb.group({
      first: ['', Validators.required],
      last: ['', Validators.required]
    })
  }

  verify() {
    if (this.collectName && this.form.invalid){
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    this.cue5050Service.setVerification(this.form.controls.first.value, this.form.controls.last.value, this.eventId).subscribe(
      () => { 
        this.hasError.emit(false);
        this.bsModalRef.hide();
      },
      error => {
        this.hasError.emit(true);
        this.bsModalRef.hide();
      }
    );
  }

  close() {
    this.bsModalRef.hide();
  }

}

